// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4162":"1c7916ffc2ff26d1","6648":"1966285586f9cdb1"}[chunkId] + ".css";
};